export default "__VITE_ASSET__N8n6nuYp__"